import React from "react";
function createMarkup(code){
    return {__html: code}
}
const CodeEmbed = ({blok}) => {
    const code = blok.code
    return ( 
        <div dangerouslySetInnerHTML={createMarkup(code)}/>
     );
}
 
export default CodeEmbed;